import React from "react";
import todayIcon1 from "src/assets/i_today1.svg";
import todayIcon2 from "src/assets/i_today2.svg";
import todayIcon3 from "src/assets/i_today3.svg";
import todayIcon4 from "src/assets/i_today5.svg";

interface TodayIconProp {
  icon: number;
}

const TodayIcon: React.FC<TodayIconProp> = ({ icon }) => {
  const iconMap: Record<number, string> = {
    0: todayIcon1,
    1: todayIcon2,
    2: todayIcon3,
    3: todayIcon4,
  };  
  return (
    <div className="stat-value"><i><img src={iconMap[icon] || null} alt="" /></i></div>
  );
};
export default TodayIcon;
